// app/javascript/controllers/payment_form_controller.js
import { Controller } from "@hotwired/stimulus"

// The payment form controller is responsible for handling the submission of the form.
// The fees have been calculated, the amount is present, fields are valid, and payment method is selected.
// The submit button is disabled until the form is ready to be submitted and when the form is submitted.

export default class extends Controller {
  static targets = ["submit", "methodType", "error"]
  static outlets = ['stripe-fields', 'plaid-fields', 'payment-method']

  connect() {
    this.setSubmitting(false)

    // Listen for fee calculations to enable/disable submit
    this.element.addEventListener("fees:calculated", this.enableSubmit.bind(this))
    this.element.addEventListener("fees:error", this.disableSubmit.bind(this))
  }

  disconnect() {
    this.element.removeEventListener("fees:calculated", this.enableSubmit.bind(this))
    this.element.removeEventListener("fees:error", this.disableSubmit.bind(this))
  }

  enableSubmit() {
    this.submitTarget.disabled = false
  }

  disableSubmit() {
    this.submitTarget.disabled = true
  }

  async submit(event) {
    event.preventDefault()

    // Prevent double submission
    if (this.submitTarget.disabled) return

    // Disable submit button
    this.setSubmitting(true)
    this.clearError()

    try {
      let canSubmit = false
      const tabType = this.paymentMethodOutlet.activeTabValue

      switch(tabType) {
        case "existing":
          canSubmit = true
          break
        case "credit_card":
          const stripeFields = this.stripeFieldsOutlet

          canSubmit = stripeFields ? await stripeFields.tokenize() : false
          break
        case "bank_account":
          const plaidFields = this.plaidFieldsOutlet
          canSubmit = plaidFields ? await plaidFields.validate() : false
          break
        default:
          console.error(`Unknown payment method type: ${tabType}`)
          break
      }

      if (canSubmit) {
        this.element.submit()
      } else {
        // Wrap in timeout to fix race condition
        setTimeout(() => this.setSubmitting(false), 500)
      }
    } catch(error) {
      console.error(error)
      this.showError(`Payment submission failed. Please try again. ${error}`)
      // Wrap in timeout to fix race condition
      setTimeout(() => this.setSubmitting(false), 500)
    }
  }

  setSubmitting(submitting) {
    this.submitTarget.disabled = submitting
    this.submitTarget.value = submitting ? "Giving..." : "Give Now"
  }

  showError(message) {
    const errorElement = this.element.querySelector(".card-error")
    if (errorElement) {
      errorElement.textContent = message
    }
  }

  clearError() {
    if (this.hasErrorTarget) {
      this.errorTarget.textContent = ''
      this.errorTarget.hidden = true
    }
  }
}
